// extracted by mini-css-extract-plugin
export var backupIcon = "_my-1";
export var image = "_my-0";